import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskJourneyConfigurationEditRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-journey-configuration-edit',
	path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId/edit',
	exact: true,
};
